import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Twitter, Linkedin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_press-studio/artifacts/4au2b8ob_Logo-02.png";

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <img 
              src={LOGO_URL} 
              alt="Velvet Press" 
              className="h-14 w-auto max-w-[250px]"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Specializing in producing high-quality, eye-catching graphic designs and printing in The Bahamas and United States.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors" data-testid="social-facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors" data-testid="social-instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors" data-testid="social-twitter">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors" data-testid="social-linkedin">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-outfit text-white text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/request-quote" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Request a Quote
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="font-outfit text-white text-lg mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shop/business-cards" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Business Cards
                </Link>
              </li>
              <li>
                <Link to="/shop/labels-stickers" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Labels & Stickers
                </Link>
              </li>
              <li>
                <Link to="/shop/promotional-items" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Promotional Items
                </Link>
              </li>
              <li>
                <Link to="/shop/signs-banners-posters" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  Signs & Banners
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="font-outfit text-white text-lg mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  3175 W Broward Blvd<br />
                  Fort Lauderdale, FL 33312
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#D4AF37] flex-shrink-0" />
                <a href="mailto:orders@velvetpress.us" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  orders@velvetpress.us
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Clock size={18} className="text-[#D4AF37] flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  Mon - Fri: 9am - 6pm
                </span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Velvet Press. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-500 hover:text-[#D4AF37] text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-[#D4AF37] text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
